import { HTMLAttributes, SyntheticEvent } from 'react';

import { trackEvent } from '@domain/analytics/trackEvent';
import { EventMykissCardClicked } from '@generated/events';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  to: string;
  eventProperties: EventMykissCardClicked['properties'];
  className?: string;
  linkClassName?: string;
  withDefaults?: boolean;
  disabled?: boolean;
  onClick?: (event: SyntheticEvent) => void;
  testId?: string;
}

export const LinkCard = ({
  disabled,
  to,
  eventProperties,
  linkClassName = '',
  className = '',
  withDefaults = true,
  onClick,
  testId = 'LinkCard',
  ...rest
}: IProps) => (
  <InternalLink
    disabled={disabled}
    to={to}
    data-testid={testId}
    variant="disabled" // fix in FIB-37696
    onClick={(e: SyntheticEvent) => {
      if (onClick) {
        onClick(e);
      }
      trackEvent({
        name: 'mykiss_card_clicked',
        properties: eventProperties,
      });
    }}
    className={linkClassName}
  >
    <div className={`${withDefaults ? 'group h-full' : ''} ${className}`} {...rest} />
  </InternalLink>
);
